import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const MercaderiaModal = ({ show, onClose, onSave, showCreate, title, categoriasEvaluacion, initDataMercaderia }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, getValues:getValuesModal, setValue : setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [detalles, setDetalles] = useState(CONFIGURACIONES.INIT.ARRAY);
    
    
    const selectCategorias = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.MERCADERIA);
    }, [categoriasEvaluacion]);

    useEffect(() => {
        resetModal();
        if (initDataMercaderia !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('totalMercaderia', initDataMercaderia.total);
            setDetalles(initDataMercaderia.detalles);
        }
    }, [initDataMercaderia]);

    useMemo(() => {
        let total = 0;
        detalles.forEach((item) => {
            total += parseFloat(item.total);
        });
        setValueModal('totalMercaderia', isNaN(total) ? '' : total.toFixed(2));
        return isNaN(total) ? '' : total.toFixed(2); 
    }, [detalles]);


    const onAgregarItem = (form) => {
        const {totalMercaderia, ...form2} = form;
        form2['id'] = Functions().generarNumeroUnico(detalles);
        // detalles.push(form);
        setDetalles([...detalles, form2]);
        resetModal();
    };

    const saveData = () => {
        let data = {
            'total': getValuesModal('totalMercaderia'),
            'detalles': detalles
        }

        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onAgregarItem)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                             <div className="col-sm-12 col-md-6">
                                <div className="form-group">
                                    <label htmlFor="producto" className="control-label col-form-label">Producto <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="producto"
                                        id="producto"
                                        {...registerModal("producto", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.producto && errorsModal.producto.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="cantidad" className="control-label col-form-label">Cantidad <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="cantidad"
                                        id="cantidad"
                                        {...registerModal("cantidad", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let cantidad = e.target.value;
                                                let precioVenta = getValuesModal('precioVenta');

                                                let total = parseFloat(cantidad || 0) * parseFloat(precioVenta || 0);
                                                setValueModal('total', isNaN(total) ? '' : total.toFixed(2), {shouldValidate: true});
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.cantidad && errorsModal.cantidad.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="precioCompra" className="control-label col-form-label">Precio de Compra <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="precioCompra"
                                        id="precioCompra"
                                        {...registerModal("precioCompra", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let precioCompra = e.target.value;
                                                let cantidad = getValuesModal('cantidad');
                                                let precioVenta = getValuesModal('precioVenta');
                                                let costoVenta = parseFloat(cantidad || 0) * parseFloat((precioCompra || 0) / (precioVenta || 1));
                                                setValueModal('costoVenta', isNaN(costoVenta) ? '' : costoVenta.toFixed(2), {shouldValidate: true});
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.precioCompra && errorsModal.precioCompra.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="precioVenta" className="control-label col-form-label">Precio de Venta <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="precioVenta"
                                        id="precioVenta"
                                        {...registerModal("precioVenta", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let precioVenta = e.target.value;
                                                let cantidad = getValuesModal('cantidad');
                                                let precioCompra = getValuesModal('precioCompra');
                                                let total = parseFloat(cantidad || 0) * parseFloat(precioVenta || 0);
                                                setValueModal('total', isNaN(total) ? '' : total.toFixed(2), {shouldValidate: true});
                                                let costoVenta = parseFloat(cantidad || 0) * parseFloat((precioCompra || 0) / (precioVenta || 1));
                                                setValueModal('costoVenta', isNaN(costoVenta) ? '' : costoVenta.toFixed(2), {shouldValidate: true});
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.precioVenta && errorsModal.precioVenta.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="total" className="control-label col-form-label">Total <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="total"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        id="total"
                                        {...registerModal("total", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.total && errorsModal.total.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="costoVenta" className="control-label col-form-label">Costo de Venta <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="costoVenta"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        id="costoVenta"
                                        {...registerModal("costoVenta", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.costoVenta && errorsModal.costoVenta.message }</small>
                                </div>
                            </div>


                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="categoria" className="control-label col-form-label">Categoría <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("categoria", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="categoria"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            selectCategorias.map((el, index) => (
                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.categoria && errorsModal.categoria.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-sm-12 col-md-3">
                                <WaveButton className="btn btn-sm btn-outline-info wave-effect" type="submit">
                                    <i className="mdi mdi-plus"></i> Agregar
                                </WaveButton>
                            </div>
                        </div>

                        {/* 📊 Tabla */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <table className="table table-sm table-hover compact-table align-middle text-wrap">
                                <thead className="bg-success text-white">
                                <tr>
                                    <th>Producto</th>
                                    <th>Cantidad</th>
                                    <th>P. Compra</th>
                                    <th>P. Venta</th>
                                    <th>Total</th>
                                    <th>Costo Venta</th>
                                    <th>Categoría</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {detalles.length > 0 ? (
                                    detalles.map((item) => (
                                        <tr key={item.id}>
                                            <td className="text-wrap">{item.producto}</td>
                                            <td className="text-wrap">{item.cantidad}</td>
                                            <td className="text-wrap">{item.precioCompra}</td>
                                            <td className="text-wrap">{item.precioVenta}</td>
                                            <td className="text-wrap">{item.total}</td>
                                            <td className="text-wrap">{item.costoVenta}</td>
                                            <td className="text-wrap">{item.categoria}</td>
                                            <td>
                                                <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                                    setDetalles(detalles.filter((detalle) => detalle.id !== item.id));
                                                }}>
                                                    <i className="mdi mdi-delete"></i>
                                                </WaveButton>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center text-muted">
                                            <span className="text-danger">No se encontraron resultados</span>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-2">
                                <div className="form-group">
                                    <label htmlFor="totalMercaderia" className="control-label col-form-label">Total <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="totalMercaderia"
                                        id="totalMercaderia"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("totalMercaderia", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.totalMercaderia && errorsModal.totalMercaderia.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="button" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default MercaderiaModal;
